import { render } from "./rateSettingsToggle.vue?vue&type=template&id=1984bb71&scoped=true"
import script from "./rateSettingsToggle.vue?vue&type=script&lang=js"
export * from "./rateSettingsToggle.vue?vue&type=script&lang=js"

import "./rateSettingsToggle.vue?vue&type=style&index=0&id=1984bb71&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1984bb71"]])

export default __exports__